import { API_PATHS } from "./apiPaths";
import { axiosInstance } from "./axiosSetup";

const ingestor = 'publisherapi';

export async function fetchFTSReports(
  startrow,
  maxrows,
  filter,
  searchq,
) {
  return axiosInstance.post(API_PATHS.PROXY_PATH, {
    queryStringParameters: {
      ingestor,
      startrow,
      maxrows,
      filter,
      searchq,
    },
    path: API_PATHS.ON_DEMAND_SCREENING_LIST_EVENTS,
    method: "get",
  });
}

export async function removeFTSReport(id) {
  return axiosInstance.post(API_PATHS.PROXY_PATH, {
    path: API_PATHS.ON_DEMAND_SCREENING_EXCLUDE_EVENT(id),
    method: "delete",
  });
}
